"use client";

import { FlexColumn, FlexRowAlignCenter } from "@/components/Flex";
import br from "@/styles/breakpoints.module.css";
import { themeColors } from "@/utils/themeColors";
import { shuffle } from "lodash-es";
import { useEffect, useState } from "react";
import { FeedbackCard } from "../../components/FeedbackCard";
import { ReviewType, USER_REVIEWS } from "../constants";
import { spacing } from "@/utils/spacing";
import { borderRadius } from "@/utils/borderRadius";

const STATS = [
    {
        stat: "3M +",
        desc: "Student & teacher users",
    },
    {
        stat: "5M +",
        desc: "Study notes created ",
    },
    {
        stat: "10M + ",
        desc: "Flashcards sets created",
    },
];

const StudentRelyOnKnowt = ({
    type,
    containerStyle,
    isWithStats,
}: {
    type: ReviewType;
    containerStyle?: React.CSSProperties;
    isWithStats?: boolean;
}) => {
    const [reviews, setReviews] = useState(USER_REVIEWS[type]);

    // Shuffle the reviews only after the component mounts - to prevent hydration error
    useEffect(() => {
        setReviews(shuffle(USER_REVIEWS[type]));
    }, [type]);

    return (
        <FlexColumn style={{ ...containerStyle }}>
            {isWithStats && (
                <FlexRowAlignCenter
                    className={br.mdDownColumn}
                    style={{ gap: spacing.MD, width: "100%", marginBottom: spacing.MD }}>
                    {STATS.map(stat => (
                        <FlexColumn
                            key={stat.stat}
                            style={{
                                width: "100%",
                                border: `1px solid ${themeColors.neutral1}`,
                                borderRadius: borderRadius.card,
                                padding: spacing.MD,
                                gap: spacing.XS,
                                backgroundColor: themeColors.neutralWhite,
                            }}>
                            <span
                                style={{
                                    fontSize: "44px",
                                    fontStyle: "normal",
                                    fontWeight: "600",
                                    lineHeight: "58px",
                                }}
                                data-testid="auto-id-53359a1c-b81c-4d43-98ca-ab6abf706403">
                                {stat.stat}
                            </span>
                            <span
                                className="secondaryText1"
                                data-testid="auto-id-f1ad360b-3e1b-4e84-bdec-40ad5a61f86d">{stat.desc}</span>
                        </FlexColumn>
                    ))}
                </FlexRowAlignCenter>
            )}
            <FeedbackCard
                users={reviews}
                gridPattern={[
                    [0, 2],
                    [2, 4],
                    [4, 6],
                ]}
            />
        </FlexColumn>
    );
};

export default StudentRelyOnKnowt;
